import { useTheme, Box, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';

interface AcknowledgementProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  gutterTop?: boolean;
}

const Acknowledgement = ({
  checked,
  onChange,
  gutterTop = false
}: AcknowledgementProps) => {
  const theme = useTheme();
  return (
    <Grid
      container
      direction='row'
      wrap='nowrap'
      sx={{
        marginTop: gutterTop ? '16px' : 0,
        padding: '16px 16px 16px 24px',
        borderRadius: '10px',
        backgroundColor: theme.palette.blueGrey[50],
      }}
    >
      <FormControlLabel
        sx={{
          alignItems: 'flex-start'
        }}
        control={<Checkbox
          name='Law Enforcement Acknowledgement'
          checked={checked}
          onChange={onChange}
          disableFocusRipple
          sx={{ padding: 0, marginRight: '8px' }}
          slotProps={{
            input: { 'aria-label': 'Law Enforcement Acknowledgement' }
          }}
        />}
        label={<Box>
          <Typography variant='bodyMedium'>
            By submitting this registration form, I affirm that I am a current law enforcement officer authorized to act and trained pursuant to applicable state and/or federal certification standards. I understand that providing false or misleading information to gain access to SurePass services may delay or deny those services, invalidate any resulting actions, and where applicable, be reported to the appropriate authority.
          </Typography>
          <Typography variant='bodyMedium' sx={{
            mt: '8px'
          }}>
            Knowingly misrepresenting oneself as a law enforcement officer may result in immediate removal from the platform and potential criminal prosecution under applicable state and federal laws.
          </Typography>
          <Typography variant='bodyMedium' sx={{
            mt: '8px'
          }}>
            I acknowledge and agree that SurePass reserves the right to verify all submitted credentials with my employing agency and will take appropriate action if my certification cannot be confirmed.
          </Typography>
        </Box>}
      />
      {/* <Box>
        <Checkbox
          name='Law Enforcement Acknowledgement'
          checked={checked}
          onChange={onChange}
          disableFocusRipple
          sx={{ padding: 0, marginRight: '8px' }}
          slotProps={{
            input: { 'aria-label': 'Law Enforcement Acknowledgement' }
          }}
        />
      </Box>
      <Box>
        <Typography variant='bodyMedium'>
          By submitting this registration form, I affirm that I am a current law enforcement officer authorized to act and trained pursuant to applicable state and/or federal certification standards. I understand that providing false or misleading information to gain access to SurePass services may delay or deny those services, invalidate any resulting actions, and where applicable, be reported to the appropriate authority.
        </Typography>
        <Typography variant='bodyMedium' sx={{ mt: '8px' }}>
          Knowingly misrepresenting oneself as a law enforcement officer may result in immediate removal from the platform and potential criminal prosecution under applicable state and federal laws.
        </Typography>
        <Typography variant='bodyMedium' sx={{ mt: '8px' }}>
          I acknowledge and agree that SurePass reserves the right to verify all submitted credentials with my employing agency and will take appropriate action if my certification cannot be confirmed.
        </Typography>
      </Box> */}
    </Grid>
  );
};

export default Acknowledgement;